import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { useAuthStore } from "hooks/useAuthStore";
import { useEffect, useState } from "react";
import { useUiStore } from "hooks/useUiStore";
import { FAQ, Preguntas } from "interfaces/authInterface";

interface AyudaProps {
  origen?: string;
}

export const PreguntasFrecuentes = ({ origen }: AyudaProps) => {
  const { seccionSelect, lstFAQ, changeSeccionSelect, startGetFAQ } =
    useAuthStore();
  const { darkMode } = useUiStore();
  const [seccion, setSeccion] = useState<number>(0);
  const [askQuestion, setAskQuestion] = useState<number>(0);
  useEffect(() => {
    startGetFAQ();
  }, []);
  useEffect(() => {
    if (seccionSelect !== 0) {
      setSeccion(seccionSelect);
    } else {
      setSeccion(0);
    }
  }, [seccionSelect]);

  const handleChange =
    (panel: number) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      changeSeccionSelect(isExpanded ? panel : 0);
    };
    const handleChangePregunta = (id: number) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setAskQuestion(isExpanded ? id : 0);
    };
  return (
    <div className="mx-auto p-6">
      {origen !== "login" ? (
        <h2 className="text-2xl font-bold text-center mb-4">
          Preguntas Frecuentes
        </h2>
      ) : null}

      {lstFAQ.map((secciones: FAQ) => (
        <Accordion
          key={secciones?.cveSeccion}
          expanded={seccion === secciones?.cveSeccion}
          onChange={handleChange(secciones?.cveSeccion)}
          sx={{
            "&.Mui-expanded": {
              backgroundColor: darkMode === "light" ? "#c2e3fb" : "#7b8084",
            },
            marginBottom: "10px",
          }}
        >
          <AccordionSummary
            aria-controls={`${secciones?.cveSeccion}-content`}
            id={`${secciones?.cveSeccion}-header`}
            expandIcon={<ArrowDropDownIcon />}
          >
            <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
              {secciones?.descripcion}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {secciones?.preguntas.map((pregunta: Preguntas) => (
              <Accordion
                key={pregunta?.idPregunta}
                sx={{
                  "&.Mui-expanded": {
                    backgroundColor:
                      darkMode === "light" ? "#e3f2fd" : "#8c9398",
                  },
                  marginBottom: "10px",
                }}
                expanded={askQuestion === pregunta?.idPregunta}
                onChange={handleChangePregunta(pregunta?.idPregunta)}
              >
                <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
                  <Typography sx={{ fontWeight: 500 }}>
                    {pregunta?.descPregunta}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: pregunta?.respuesta_unica?.descRespuesta || "",
                    }}
                  />
                </AccordionDetails>
              </Accordion>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
      {origen === "login" ? (
        <>
          <div className="my-5 text-center">
            {" "}
            <Link to="/login">
              <Button
                startIcon={<FiArrowLeft />}
                type="button"
                variant="contained"
                color="error"
              >
                REGRESAR
              </Button>
            </Link>
          </div>
        </>
      ) : null}
    </div>
  );
};
